import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import { FlexContainer, StyledFlag } from './styled';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    languageCode: string;
}

const Form = (props: Props) => {
    const { baseInputProps, languageCode } = props;

    const countryCode = languageCode.split('-').pop();

    return (
        <FlexContainer>
            <CustomInput {...baseInputProps} name='description' flex='4' />
            <CustomInput {...baseInputProps} name='code' flex='2' inputProps={{maxLength: 5}} />
            <div>
                <StyledFlag code={countryCode} />
            </div>
        </FlexContainer>
    );
};

export default Form;
